export default "skymp5-front/3247b72559198c2814645e1ea3f3d312.png";